// All money is integer cents. Never use floating point for stored amounts.

export type Cents = number;

export function assertCents(n: number, label = 'amount'): asserts n is Cents {
  if (!Number.isInteger(n)) throw new Error(`${label} must be integer cents, got ${n}`);
}

export function formatUsd(c: Cents): string {
  const sign = c < 0 ? '-' : '';
  const abs = Math.abs(c);
  return `${sign}$${Math.floor(abs / 100).toLocaleString('en-US')}.${String(abs % 100).padStart(2, '0')}`;
}

/** Parse "$1,234.56", "1234.5", "-3.00" into cents. Returns null when not a number. */
export function parseUsd(s: string | number | null | undefined): Cents | null {
  if (s === null || s === undefined) return null;
  if (typeof s === 'number') return Number.isFinite(s) ? Math.round(s * 100) : null;
  const t = s.replace(/[$,\s]/g, '');
  if (t === '' || !/^-?\d*(\.\d+)?$/.test(t)) return null;
  return Math.round(Number(t) * 100);
}

/** Integer division rounding up (toward +infinity) for positive numerators. */
export function ceilDiv(a: number, b: number): number {
  if (b <= 0) throw new Error('divisor must be positive');
  return Math.ceil(a / b);
}

/** Round half-up to whole cents. */
export function roundHalfUp(x: number): Cents {
  return Math.sign(x) * Math.floor(Math.abs(x) + 0.5);
}
